import { MaskedLines, Reveal, Overline } from "./shared";
import { LightArt } from "./LightArt";

const WORLDS = [
    { n: "01", title: "Kinetic Light", desc: "Lighting that moves, changes and responds — illumination as a living material.", variant: "rods", hue: "warm" },
    { n: "02", title: "Kinetic Walls", desc: "Walls that transform through coordinated movement — surfaces with a pulse.", variant: "grid", hue: "mixed" },
    { n: "03", title: "Kinetic Sculptures", desc: "Mechanical movement transformed into art — machines that behave like dancers.", variant: "rings", hue: "cool" },
    { n: "04", title: "Interactive Spaces", desc: "Installations that respond to people, movement and gesture — spaces that notice you.", variant: "burst", hue: "mixed" },
    { n: "05", title: "Motion Architecture", desc: "Moving architectural elements designed specifically for a space — buildings that breathe.", variant: "wave", hue: "cool" },
    { n: "06", title: "Signature Installations", desc: "Completely custom works created around a brand, a building or an idea.", variant: "halo", hue: "warm" },
];

export const Worlds = () => (
    <section id="experiences" data-testid="worlds-section" className="relative py-32 md:py-48">
        <div className="mx-auto max-w-[1600px] px-6 md:px-12">
            <Overline>Installation Worlds</Overline>
            <h2 className="mt-10 font-display text-4xl font-bold uppercase leading-[0.95] tracking-tight sm:text-6xl lg:text-7xl">
                <MaskedLines lines={["Enter the world", "of motion"]} />
            </h2>
            <div className="mt-24 space-y-24 md:mt-32 md:space-y-40">
                {WORLDS.map((w, i) => (
                    <Reveal key={w.n} className={`group flex flex-col gap-10 md:items-center ${i % 2 ? "md:flex-row-reverse" : "md:flex-row"}`}>
                        <div className="relative h-[46vh] w-full overflow-hidden border border-white/10 md:h-[64vh] md:w-[58%]">
                            <LightArt
                                variant={w.variant}
                                hue={w.hue}
                                className="h-full w-full transition-transform duration-[1400ms] ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-[1.04]"
                            />
                            <span className="absolute left-6 top-6 font-mono-tech text-[10px] tracking-[0.35em] text-white/40">{w.n}</span>
                        </div>
                        <div className={`md:w-[42%] ${i % 2 ? "md:pr-16" : "md:pl-16"}`}>
                            <span className="font-mono-tech text-[10px] tracking-[0.35em] text-white/35">{w.n} — WORLD</span>
                            <h3 className="mt-4 font-display text-3xl font-bold uppercase tracking-tight text-white sm:text-4xl lg:text-5xl">
                                {w.title}
                            </h3>
                            <p className="mt-6 max-w-md text-base font-light leading-relaxed text-white/60 md:text-lg">{w.desc}</p>
                            <span className="mt-8 block h-px w-24 bg-white/20 transition-[width] duration-700 group-hover:w-40" />
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
